import React from 'react';
import { FormattedDate } from 'react-intl';
import PropTypes from 'prop-types';
import FormattedDateShort from '../../shared/components/FormattedDateShort';

const EidDetail = ({ document }) => {
  if (!document.recognitionMeta) return null;
  const eid =
    typeof document.recognitionMeta === 'string'
      ? JSON.parse(document.recognitionMeta)
      : document.recognitionMeta;
  return (
    <div className="margin10B">
      <div>
        <label>
          {eid.firstName} {eid.lastName}
        </label>
      </div>
      <div>
        <label>
          {eid.street}, {eid.zip} {eid.city}
        </label>
      </div>
      <div>
        <label>
          <FormattedDateShort value={eid.dateOfBirth} />
        </label>
      </div>
      <div>
        <label>{eid.nationalNumber}</label>
      </div>
    </div>
  );
};

EidDetail.propTypes = {
  document: PropTypes.shape({}).isRequired,
};

export default EidDetail;
